import { render } from "./sysTenantTemp.vue?vue&type=template&id=a5b063ce"
import script from "./sysTenantTemp.vue?vue&type=script&lang=js"
export * from "./sysTenantTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__